<template>
  <a-radio-group
    v-if="props.useGrid"
    v-bind="attrs"
    :class="[bem.b(), bem.is('use-grid')]"
    :option-type="optionType"
  >
    <a-row
      :gutter="[gutterHorizontal, gutterVertical]"
      v-bind="props.rowOptions"
    >
      <a-col
        v-for="(item, idx) in props.options"
        v-bind="item.colOptions"
        :key="idx"
        :span="item.span || props.allSpan"
        :class="bem.e('item')"
      >
        <a-radio v-bind="item">
          <slot v-bind="{ ...item, idx }">
            <ll-icon
              v-if="item.icon && optionType === 'button'"
              :icon-name="item.icon"
            />
            {{ item.label }}
          </slot>
        </a-radio>
      </a-col>
    </a-row>
  </a-radio-group>
  <a-radio-group
    v-else
    v-bind="attrs"
    :class="[bem.b(), bem.is(groupDirection)]"
    :style="itemSpace"
    :option-type="optionType"
  >
    <template v-for="(option, idx) in options" :key="idx">
      <a-radio v-bind="option">
        <slot v-bind="{ ...option, idx }">
          <ll-icon
            v-if="option.icon && optionType === 'button'"
            :icon-name="option.icon"
          />
          {{ option.label }}
        </slot>
      </a-radio>
    </template>
  </a-radio-group>
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { radioGroupProps } from './radio'

import { createNamespace } from '@ll-plus/utils'

const props = defineProps(radioGroupProps)

defineOptions({ name: 'LlRadioGroup' })
const attrs = useAttrs()
const bem = createNamespace('radio-group')

const groupDirection = computed(() =>
  props.direction === 'vertical' && props.optionType !== 'button'
    ? 'vertical'
    : 'horizontal'
)

const itemSpace = computed(() => ({
  gap: props.optionType !== 'button' ? props.itemSpace + 'px' : 0,
}))
</script>
